var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_location",
    d: "M7 12.5H9V9.5H12V7.5H9V4.5H7V7.5H4V9.5H7V12.5ZM8 17.85C10.0333 15.9833 11.5417 14.2875 12.525 12.7625C13.5083 11.2375 14 9.88333 14 8.7C14 6.88333 13.4208 5.39583 12.2625 4.2375C11.1042 3.07917 9.68333 2.5 8 2.5C6.31667 2.5 4.89583 3.07917 3.7375 4.2375C2.57917 5.39583 2 6.88333 2 8.7C2 9.88333 2.49167 11.2375 3.475 12.7625C4.45833 14.2875 5.96667 15.9833 8 17.85ZM8 20.5C5.31667 18.2167 3.3125 16.0958 1.9875 14.1375C0.6625 12.1792 0 10.3667 0 8.7C0 6.2 0.804167 4.20833 2.4125 2.725C4.02083 1.24167 5.88333 0.5 8 0.5C10.1167 0.5 11.9792 1.24167 13.5875 2.725C15.1958 4.20833 16 6.2 16 8.7C16 10.3667 15.3375 12.1792 14.0125 14.1375C12.6875 16.0958 10.6833 18.2167 8 20.5Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cf35338650360cfce5c55b964c56b711.svg";
export { ForwardRef as ReactComponent };